module.exports = __webpack_public_path__ + "static/media/entregarinju7.d8fbe17f.jpg";